// extracted by mini-css-extract-plugin
export default {"gridContainer":"drink-list_gridContainer__VoEOC"};